import React from 'react';
import {
    BetColumn,
    BetSection,
} from 'src/domains/players/webview/components/Account/betHistoryTab/betsList/betsList/Bet.style';
import { BetDetails } from 'src/domains/players/webview/components/Account/betHistoryTab/betsList/betsList/BetDetails';
import { observer } from 'src/utils/mobx-react';
import { BogBonusMessage } from 'src/domains/players/webview/components/Account/betHistoryTab/betsList/betsList/BogBonusMessage';
import { BetStake } from 'src/domains/players/webview/components/Account/betHistoryTab/betsList/betsList/BetStake';
import { OpenapiProxyCustomerBonusesResponse200Type } from 'src/api_openapi/generated/openapi_proxy_customer_bonuses';
import { BetHistoryType } from 'src/domains/players/webview/components/Account/betHistoryTab/BetHistoryTab.state';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { UsersState } from 'src/domains/players/state/UsersState';

interface PropsType {
    bet: BetHistoryType;
    bonuses: OpenapiProxyCustomerBonusesResponse200Type;
}

export const Bet = observer<PropsType>('Bet', ({ bet, bonuses }) => {
    const common = useCommon();
    const configComponents = ConfigComponents.get(common);
    const configState = configComponents.config;
    const usersState = UsersState.get(common);

    const payout = bet.status === 'open' ? null : bet.payout ?? null;
    const stake = usersState.money(configComponents.precision.newFromAnything(bet.totalStake));
    const freeBetCredits = bet.transaction.tags.freebetCredits;
    const isFreeBet = freeBetCredits.length > 0;
    const betBonusTypes = bet.transaction.tags.bonuses;
    const bogBonus = betBonusTypes.find((elem) => elem.type === 'best-odds-guaranteed') ?? null;
    const payoutForView =
        payout === null
            ? null
            : bogBonus === null
              ? configComponents.precision.newFromAnything(payout)
              : configComponents.precision
                    .newFromAnything(payout)
                    .add(configComponents.precision.newFromAnything(bogBonus.amount));
    const result = payoutForView === null ? '-' : usersState.money(payoutForView);

    return (
        <BetSection
            data-test='bet-list-item'
            data-test-bet-type={bet.type}
            variant={configState.componentVariants.accountSectionVariant}
        >
            <BetDetails bet={bet} />
            <BetColumn>
                <BetStake
                    isFreeBet={isFreeBet}
                    stake={stake}
                />
            </BetColumn>
            <BetColumn>
                <span
                    data-test='bet-return'
                    title={result}
                >
                    {result}
                </span>
            </BetColumn>
            <BogBonusMessage
                betBonusTypes={betBonusTypes}
                bonuses={bonuses}
            />
        </BetSection>
    );
});
